import types from "../types/commonActionTypes"

export const setShowReleaseNotes = (payload) => {
    return { type: types.SET_SHOW_RELEASE_NOTES, payload }
}